<template>
  <b-modal
    :visible="visible"
    @hide="onCancel"
    :title="getContentItem('OrderQuantityCostConfirmation')"
    :ok-title="getContentItem('Confirm')"
    :cancel-title="getContentItem('Cancel')"
    @ok="onConfirm"
    @cancel="onCancel"
    :ok-disabled="false"
    :cancel-disabled="false"
  >
    <div>
      <p>{{ getContentItem('ThresholdExceedMessage') }}</p>
      <ul>
        <li>{{ getContentItem('QuantityThreshold') }}: {{ getContentItem('MoreThan') }} {{ maxQuantity }} {{ getContentItem('pieces') }}</li>
        <li>{{ getContentItem('CostThreshold') }}: {{ getContentItem('MoreThan') }} {{ maxCost }} €</li>
      </ul>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>{{ getContentItem('PartNumber') }}</th>
            <th>{{ getContentItem('Description') }}</th>
            <th>{{ getContentItem('Qty') }}</th>
            <th>{{ getContentItem('TotalCost') }}</th>
            <th>{{ getContentItem('Exceeds') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.Id">
            <td>{{ item.OemPartCode }}</td>
            <td>{{ item.PartDescription }}</td>
            <td>{{ item.Quantity }}</td>
            <td>{{ item.TotalPrice }}</td>
            <td>
              <span v-if="item.Quantity > maxQuantity">{{ getContentItem('Quantity') }}</span>
              <span v-if="item.TotalPrice > maxCost">{{ item.Quantity > maxQuantity ? ' & ' : '' }}{{ getContentItem('Cost') }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p>{{ getContentItem('PleaseReviewAndConfirm') }}</p>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'ThresholdConfirmationDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    maxQuantity: {
      type: Number,
      default: 100
    },
    maxCost: {
      type: Number,
      default: 5000
    }
  },
  computed: {
    ...mapGetters([
      "getContentItem"
    ])
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 1rem;
}
</style>
